<template>
  <div class="osmd-measure" :class="rootClass">
    <div v-if="error" class="px-1  text-[11px] text-red-500">Render-Fehler</div>
    <div ref="containerRef" class="osmd-canvas" :style="{width, height}"/>
  </div>
</template>

<script setup lang="ts">
import {useOsmdRenderer} from '@/composables/useOsmdRenderer';
import type {IOSMDOptions} from "osmd-types-player";
import {onMounted} from "vue";

const {
  width, height,
  options = {cursorsOptions: [], autoResize: false, disableCursor: true}, musicXml, zoom = 0.5, class: rootClass = ''
} = defineProps<{
  musicXml: string;
  zoom?: number;
  class?: string;
  width?: number | string;
  height?: number | string;
  options?: IOSMDOptions;
}>();

const {containerRef, error} = useOsmdRenderer(() => musicXml, {zoom}, options);
onMounted(() => {
  let container = containerRef.value;
  if (!container) return;
  if (width) {
    container.style.width = "number" === typeof width ? `${width}px` : width
  }
  if (height) {
    container.style.height = "number" === typeof height ? `${height}px` : height
  }
})
</script>

<style scoped>
@import 'tailwindcss';

.osmd-measure {
  @apply w-full overflow-hidden content-center;
}

.osmd-canvas {
  @apply max-w-full  overflow-hidden max-h-max content-center;
}

.osmd-canvas :deep(svg) {
  @apply max-w-full;
}
</style>
